import { ToolkitOrder, expected } from '@aloft/toolkit-shared';

import { TkOrderListing } from '../../modules/orderManagement/components/OrderTable/types.ts';
import { processOrderTags } from '../../utils/processOrderTags.ts';

export function tkv2ToOrderListing({
  id,
  input,
  createdAt,
  isArchived,
  isTraining,
  subjectAddress,
  requiresPrefill,
  appraisalType,
  clientName,
  appraiserFee,
  dueDate,
  inspectionDate,
  appraiserInstructions,
  intendedUsers,
  intendedUse,
  inspectorType,
  isInspectifyOrder,
  borrowerName,
  signedAt,
  isCompleted,
  appraisifyFee,
  isRevision,
  isMock,
}: ToolkitOrder): Omit<TkOrderListing, 'toggleArchive' | 'deleteOrder' | 'downloadReport' | 'openDocumentsPage'> {
  return {
    createdAt,
    isArchived,
    isTraining,
    requiresPrefill,
    inspectifyOrder: isInspectifyOrder,
    id: expected(id),
    type: 'tkv2' as const,
    address: subjectAddress,
    effectiveDate: input?.effectiveDate,
    propertyType: input?.propertyType,
    orderNumber: input?.orderNumber,
    isCraftsman: input?.isCraftsman,
    appraisalType,
    clientName,
    appraiserFee,
    dueDate: isMock ? undefined : dueDate,
    inspectionDate,
    appraiserInstructions,
    intendedUsers,
    intendedUse,
    inspectorType,
    borrowerName,
    tags: processOrderTags({
      dueDate,
      isCompleted: isCompleted ?? false,
      revisionType: input.revisionData?.revisionType,
      isMock: isMock ?? false,
    }),
    isCompleted,
    signedAt,
    inspectionData: input?.inspectionData,
    appraisifyFee,
    isRevision,
    isMock,
  };
}
